import { ProcessingText } from 'core-components/library/loader'

import { ActionsSelector } from './ActionsSelector'

import styles from './HeadWithActions.module.scss'
import { FlexGridWrapperActionsContext } from 'core-components/sitebuilder/layout/flexGridWrapper/context/FlexGridWrapperActionsContext'
import { useCallback, useContext } from 'react'

interface IAdditionalHead {
  alertMessageVisible: boolean
  actionSelectorVisible: boolean
  importSettingsCallback: () => void // TODO: move here?
}

export const HeadWithActions = ({
  alertMessageVisible,
  actionSelectorVisible,
  importSettingsCallback,
}: IAdditionalHead) => {
  const { isActionInProgress, resetToDefault, exportSettings, saveAsDefault } = useContext(
    FlexGridWrapperActionsContext
  )

  const actionSelectorHandler = useCallback(
    async (id: string) => {
      switch (id) {
        case 'toDefault':
          await resetToDefault()
          break
        case 'import-settings':
          importSettingsCallback()
          break
        case 'export-settings':
          exportSettings()
          break
        case 'save':
          await saveAsDefault()
      }
    },
    [exportSettings, importSettingsCallback, resetToDefault, saveAsDefault]
  )

  return (
    <>
      {isActionInProgress ? (
        <div className={styles.attention}>
          <ProcessingText />
        </div>
      ) : alertMessageVisible ? (
        <div className={styles.attention}>Attention! You have a personal settings.</div>
      ) : null}

      {actionSelectorVisible ? <ActionsSelector onChoose={actionSelectorHandler} /> : null}
    </>
  )

  return null
}
